<div class="container">
  <header class="page-header-title" i18n>Content details</header>
  <div class="subline" (click)="backToContent()">
    <button class="skideo-flat-button white">
      <img src="assets/icons/arrow-left.svg" alt="back" i18n-alt />
    </button>
    <p i18n>Back</p>
  </div>

  <div class="content-card-background">
    @if (contentItem !== null) {
      <div class="body-top clearfix">
        <div class="body-top-left">
          @if (contentItem.type === ImageTypeEnum.Image || contentItem.type === ImageTypeEnum.GIF) {
            <img src="{{ contentItem.url }}" (click)="openModal(contentItem.url, contentItem.type)" alt="" />
          }
          @if (contentItem.type === ImageTypeEnum.Video) {
            <div class="video-wrapper" (click)="openModal(contentItem.url, contentItem.type)">
              <i class="fas fa-play video-play-icon"></i>
              <video src="{{ contentItem.url }}"></video>
            </div>
          }
        </div>
        <div class="body-top-right">
          <div class="body-top-content clearfix">
            <h2>{{ contentItem.title }}</h2>
            <div>
              @if (contentItem.templateItem.template.items.length > 1) {
                <p class="template-item-title">{{ contentItem.templateItem.template.title }} / {{ contentItem.templateItem.title }}</p>
              }
              @if (contentItem.templateItem.template.items.length === 1) {
                <p class="template-item-title">
                  {{ contentItem.templateItem.template.title }}
                </p>
              }
              <p class="deliveries">{{ contentItem.views.totalCount }} <ng-container i18n>Views</ng-container></p>
              <br />
            </div>
            <div class="header-input-wrapper">
              <i class="fas fa-link input-icon"></i>
              <input [value]="shareUrl" name="shareUrl" />
              <button ngxClipboard [cbContent]="shareUrl" (click)="copyUrl()">
                <i class="far fa-clone button-icon"></i> <ng-container i18n>Copy</ng-container>
              </button>
            </div>
            <div>
              <a class="content-buttons" [href]="contentItem.downloadUrl" download target="_blank"
                ><i class="far fa-arrow-to-bottom content-button-icon"></i> <ng-container>Download item</ng-container></a
              >
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
